import React, { useState, useEffect } from 'react'
import { Grid, Paper, Table, TableRow, TableCell, TableContainer, TableHead, TableBody } from "@mui/material"
import * as commonAction from "../../containers/Common/actions"
import moment from "moment"
import { toastSuccess, toastError } from '../../utils'

export default function ReportsRequests(props) {

    const [reports, setReports] = useState([])

    useEffect(() => {
        onGetReportRequests()
    }, [])

    const onGetReportRequests = () => {
        props.setLoader(true)
        commonAction.getReportRequestAdmin().then(res => {
            props.setLoader(false)
            const newReports = Array.isArray(res.body) ? res.body : []
            setReports([...newReports])
        }).catch(err => {
            props.setLoader(false)
            setReports([])
            toastError(err?.message || 'Failed to load report requests');
        })
    }

    const onConfirmDelivered = (id, status) => {
        props.setLoader(true)
        commonAction.confirmReportDeliveryAdmin({ report_id: id, status: status }).then(res => {
            onGetReportRequests()
            toastSuccess(res.message)
            props.setLoader(false)
        }).catch(err => {
            props.setLoader(false)
            toastError(err?.message || 'Failed to confirm delivery')
        })
    }

    return (
        <Grid container>
            {/* <Grid item xs={12}>
                <h2>Report Request</h2>
            </Grid> */}

            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table className="universal-table">
                        <TableHead>
                            <TableRow style={{ background: "linear-gradient(90deg, rgba(19,153,121,1) 0%, rgba(18,180,161,1) 45%, rgba(5,150,179,1) 100%)" }}>
                                <TableCell className="color-white">No.</TableCell>
                                <TableCell className="color-white" >Name</TableCell>
                                <TableCell className="color-white" >Email</TableCell>
                                <TableCell className="color-white" >Start Date</TableCell>
                                <TableCell className="color-white" >End Date</TableCell>
                                <TableCell className="color-white" >Store</TableCell>
                                <TableCell className="color-white" >Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                reports.length ? reports.map((item, key) => {
                                    return <TableRow key={key}>
                                        <TableCell>{key + 1}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.email}</TableCell>
                                        <TableCell>{moment(Number(item.start_date)).format('DD/MM/yyyy')}</TableCell>
                                        <TableCell>{moment(Number(item.end_date)).format('DD/MM/yyyy')}</TableCell>
                                        <TableCell>{item.store}</TableCell>
                                        <TableCell>
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <div className="admin-delivered">
                                                    <span onClick={() => onConfirmDelivered(item.report_id, 1)}>Deliver</span>
                                                </div>
                                                <div className="admin-rejected">
                                                    <span onClick={() => onConfirmDelivered(item.report_id, 2)}>Reject</span>
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                }) : <TableRow>
                                        <TableCell align="center" colSpan="7">No Report Found.</TableCell>
                                    </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}
